import styled, { css } from 'styled-components';

const defaultStyles = css`
  width: 100%;
  padding: 14px 24px;
  background-color: ${props => props.color || props.theme.colors.porterPrimary};
  color: ${props => props.theme.colors.white};
  border: none;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const primaryStyles = css`
  flex: 1;
  padding: 16px;
  background-color: ${props => props.color || props.theme.colors.porterPrimary};
  color: ${props => props.theme.colors.white};
  border: none;
  border-radius: 8px;
  font-size: 16px;
  line-height: 1;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const outlinedStyles = css`
  flex: 1;
  padding: 16px;
  background-color: transparent;
  color: ${props => props.color || props.theme.colors.porterSecondary};
  border: 1px solid
    ${props => props.color || props.theme.colors.porterSecondary};
  border-radius: 8px;
  font-size: 16px;
  line-height: 1;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: ${props =>
      props.color || props.theme.colors.porterSecondary};
    color: ${props => props.theme.colors.white};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const getVariantStyles = {
  primary: primaryStyles,
  outlined: outlinedStyles,
  default: defaultStyles,
};

export const Button = styled.button`
  ${props => getVariantStyles?.[props.$variant] || defaultStyles}
`;
